module.exports = __webpack_public_path__ + "img/circle-y.aab4a324.svg";